class ReportFieldDesignerVM {
    isValid = ko.observable(true);
    invalidMessage = ko.observable("");
    duplicatedName = ko.observable(false);
}